import { Box, Button, Divider, HStack, Image, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';

import { AppDispatch } from '../store';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { makeProductPurchase } from '../store/actions';
import { productType } from '../types';
import { useAppDispatch } from '../hooks';
import { usePaystackPayment } from 'react-paystack';

export const ProductCard = (props: productType) => {

    const { image, name, price = 0, description, company_id, email, supplier_url, supplier, shipping_amount = 0 } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [quantity, setQuantity] = useState<number>(1);

    const dispatch: AppDispatch = useAppDispatch();

    const total = (Number(`${price}00`) * quantity) + Number(`${shipping_amount}00`);

    const config: any = {
        reference: company_id || '',
        email: email || '',
        amount: total,
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLICK_KEY,
        currency: 'ZAR',
    };

    const initializePayment = usePaystackPayment(config);

    const _onClose = () => {
        console.log('closed');
    };

    const handlePayment = () => {
        initializePayment((reference: void) => {
            const data: any = reference;
            const values: any = { name, description, price, image, supplier, supplier_url, shipping_amount, reference: data?.reference };
            dispatch(makeProductPurchase(values));
        }, _onClose);
    };

    return (
        <>
            <Box w='100%'>
                <Stack borderRadius={8} shadow={'md'} p={2}>
                    <Image
                        borderTopRadius={6}
                        w={200}
                        h={150}
                        objectFit='cover'
                        src={image}
                        alt={image}
                    />
                    <Stack>
                        <HStack justifyContent={'space-between'}>
                            <Text textTransform={'capitalize'} fontWeight={'medium'}>{name}</Text>
                            <Text textTransform={'capitalize'} fontWeight={'bold'} color={'green'}>R{price * quantity}</Text>
                        </HStack>
                        <HStack justifyContent={'space-between'} style={{ alignItems: 'flex-start' }}>
                            <Stack>
                                <Text fontSize={12} color={'#9e9e9e'} noOfLines={[1, 2, 3]}>{description}</Text>
                                <Link fontSize={12} color={'#03a9f4'} href={supplier_url} isExternal mt={'0px !important'}>{supplier}</Link>
                            </Stack>
                            <Button colorScheme={'yellow'} size={'sm'} onClick={onOpen}>Buy</Button>
                        </HStack>
                    </Stack>
                </Stack>
            </Box>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textTransform={'capitalize'}>Order {name}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack bg={'#fafafa'} p={6} borderRadius={6}>
                            <HStack justifyContent={'space-between'}>
                                <HStack>
                                    <Image w={50} h={50} src={image} alt={image} borderColor={'gray'} borderWidth={1} />
                                    <Stack>
                                        <Text fontSize={16} fontWeight={'semibold'} textTransform={'capitalize'}>{name}</Text>
                                        <Text fontSize={14} fontWeight={'light'} mt={'0px !important'}>{description}</Text>
                                    </Stack>
                                </HStack>
                                <Stack>
                                    <Text textAlign={'right'} fontSize={16} fontWeight={'bold'} color={'#4caf50'}>R{price * quantity}</Text>
                                    <HStack>
                                        <Button size={'sm'} disabled={quantity === 1} onClick={() => setQuantity(quantity - 1)}>-</Button>
                                        <Text>{quantity}</Text>
                                        <Button size={'sm'} onClick={() => setQuantity(quantity + 1)}>+</Button>
                                    </HStack>
                                </Stack>
                            </HStack>
                            <Divider />
                            <HStack justifyContent={'space-between'}>
                                <Stack>
                                    <Text color={'gray.500'}>Subtotal</Text>
                                    <Text color={'gray.500'}>Shipping</Text>
                                </Stack>
                                <Stack>
                                    <Text textAlign={'right'} fontWeight={'bold'}>R{price * quantity}</Text>
                                    <Text textAlign={'right'} fontWeight={'bold'}>R{shipping_amount}</Text>
                                </Stack>
                            </HStack>
                            <Divider />
                            <HStack justifyContent={'space-between'}>
                                <Text fontWeight={'bold'}>Total</Text>
                                <Text textAlign={'right'} fontWeight={'bold'}>R{(price * quantity) + shipping_amount}</Text>
                            </HStack>
                        </Stack>
                        <Stack bg={'#fafafa'} p={6} borderRadius={6} mt={4}>
                            <Text fontWeight={'semibold'}>Delivery Address:</Text>
                            <Text>We&apos;ll use company address at the moment!!</Text>
                        </Stack>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={onClose}>
                            Close
                        </Button>
                        <Button colorScheme={'yellow'} rightIcon={<ArrowForwardIcon />} onClick={handlePayment}>Checkout</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};